import React from 'react';
import { cx } from '@emotion/css';
import Image from 'next/image';

import styles from './PaymentStructureView.module.scss';

export const PaymentStructureView = () => {
  return (
    <section className={styles.payment_structures}>
      <div className={styles.container}>
        <div className={styles.root}>
          <div className={styles.payment_management}>
            <div
              className={styles.pay_image}
              data-aos="fade-up"
              data-aos-delay="200">
              <Image
                src="/images/propertyManager/payment/pay.svg"
                alt="payment structure"
                width={478}
                height={351}
              />
            </div>
            <div
              className={styles.pay_complexities}
              data-aos="fade-up"
              data-aos-delay="250">
              <h5 className={styles.h5}> Payment Terms That Works For You</h5>

              <p className={cx(styles.pay_complexities_p, styles.p)}>
                Understanding the complexities of property management payment
                structures, we offer flexible credit accounts for most property
                management companies, allowing you to pay via your portfolio's
                monthly rent cycle.
              </p>
            </div>
          </div>

          <div className={styles.qeeper_integrates}>
            <div className={styles.qeeper_integrates_inner}>
              <div className={styles.integrates_systems}>
                <p className={cx(styles.integrates_systems_p, styles.p)}>
                  Qeeper integrates seamlessly with your existing systems,
                  <b> including Fixflo</b> and other Property Management Systems
                  (PMS).
                </p>
              </div>
              <div className={styles.fix_flow_row}>
                <div className={styles.convenience_imge}>
                  <Image
                    alt="fixflo"
                    src="/images/propertyManager/payment/fixflo.png"
                    width={618.8}
                    height={366.93}
                  />
                </div>
                <div className={styles.convenience_text}>
                  <h5 className={styles.h5}>Smart Integration & Dashboard</h5>
                  <p className={cx(styles.convenience_text_p, styles.p)}>
                    Qeeper seamlessly integrates with Fixflo and other Property
                    Management Systems (PMS). Our user-friendly dashboard
                    enables easy job creation, progress tracking, and document
                    management – from work reports to invoices.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
